import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-large-spinner',
  templateUrl: './large-spinner.component.html',
  styleUrls: ['./large-spinner.component.scss']
})
export class LargeSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
